/* eslint-disable react/no-danger */
/* eslint-disable prefer-template */
/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import {
  Card,
  Chip,
  IconButton,
  Stack,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import { OptionDto, TestDto } from '../../dto/TestDto';
import { IApiResult } from '../../interface/IApiResult';
import { apiSaveTest } from '../../service/apiSaveTest';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { MyAlert } from '../UI/MyAlert';
import styles from './Dialog.module.css';
import { MyTextFiled } from '../UI/MyTextField';

interface Props {
  num: number;
  isEdit: boolean;
  keyTitle: string;
  titleName: string;
  dto?: TestDto;
}

export const DialogTestItem: FunctionComponent<Props> = ({
  num,
  isEdit,
  keyTitle,
  titleName,
  dto,
}) => {
  // Функция рендеринга для text
  const renderTextOptions = () => {
    if (
      !dto ||
      (dto.type !== 'text' &&
        dto.type !== 'word_part_selection' &&
        dto.type !== 'latin_ending_picker' &&
        dto.type !== 'ordering')
    )
      return null;

    const options = dto.options as string[];
    const correctOptions = (dto.correctOptions as string[]) || [];

    return (
      <Stack spacing={1} width="100%">
        <Typography fontWeight={600} fontSize="12px">
          Варианты ответов:
        </Typography>
        {options?.map((item, index) => {
          const isCorrect = correctOptions.includes(item);
          return (
            <Typography
              key={index}
              fontSize="12px"
              sx={{
                color: isCorrect ? '#2e7d32' : '#000000',
                fontWeight: isCorrect ? 600 : 400,
                backgroundColor: isCorrect
                  ? 'rgba(46, 125, 50, 0.08)'
                  : 'transparent',
                padding: '2px 8px',
                borderRadius: '4px',
                display: 'inline-block',
                '&:hover': {
                  backgroundColor: isCorrect
                    ? 'rgba(46, 125, 50, 0.15)'
                    : 'rgba(0,0,0,0.02)',
                },
              }}
            >
              {isCorrect && '✅ '}
              {`${index + 1}. ${item}`}
              {isCorrect && ' ✓'}
            </Typography>
          );
        })}
      </Stack>
    );
  };

  // Обработка инлайн-разметки
  const processInlineMarkdown = (text: string): string =>
    text
      .replace(
        /\*\*(.*?)\*\*/g,
        `<strong class="${styles.previewStrong}">$1</strong>`
      )
      .replace(/\*(.*?)\*/g, `<em class="${styles.previewEm}">$1</em>`)
      .replace(/`(.*?)`/g, `<code class="${styles.previewCode}">$1</code>`)
      .replace(
        /!\[(.*?)\]\((.*?)\)/g,
        `<img alt="$1" src="$2" class="${styles.previewImage}" />`
      )
      .replace(
        /\[(.*?)\]\((http.*?)\)/g,
        `<a href="$2" target="_blank" class="${styles.previewLink}">$1</a>`
      );

  // Экранирование HTML
  const escapeHtml = (text: string): string => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  // Замена переносов строк перед ---
  const rereplaceMarkdpwn = (text: string): string => {
    let replacetetxt = text;
    replacetetxt = replacetetxt.replaceAll(
      '\r\n\r\n\r\n\r\n---',
      '\n&nbsp;---'
    );
    replacetetxt = replacetetxt.replaceAll('\r\n\r\n\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\r\n\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\r\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n\n---', '\n&nbsp;---');
    replacetetxt = replacetetxt.replaceAll('\n---', '\n&nbsp;---');
    return replacetetxt;
  };

  // Предобработка Markdown для списков
  const preprocessMarkdown = (text: string): string => {
    const lines = text.split('\n');
    let inNumberedList = false;
    let counter = 0;
    let currentLevel = 0;

    const processed = lines.map((line) => {
      const trimmed = line.trim();
      const numberedMatch = line.match(
        /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/
      );
      const bulletMatch = line.match(/^[-*+]\s/);
      const isEmpty = trimmed === '';
      const isHeading = /^#{1,6}\s/.test(trimmed);

      if (isEmpty || isHeading) {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      }

      if (numberedMatch) {
        const numberStr = numberedMatch[1];
        const levels = numberStr.split('.').map(Number);
        currentLevel = levels.length;
        counter = levels[levels.length - 1] || 1;
        inNumberedList = true;
        return line;
      } else if (bulletMatch && inNumberedList) {
        return line;
      } else if (bulletMatch) {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      } else {
        inNumberedList = false;
        counter = 0;
        currentLevel = 0;
        return line;
      }
    });

    return processed.join('\n');
  };

  // Рендеринг Markdown в HTML
  const renderMarkdown = (text: string): string => {
    if (!text) return '';

    const preprocessedText = preprocessMarkdown(text);
    const processedText = rereplaceMarkdpwn(preprocessedText);
    const lines = processedText.split('\n');
    let inCodeBlock = false;
    let inList = false;
    let listTag = 'ol';
    let listBuffer: string[] = [];
    let currentListLevel = 0;
    let listCounter = 1;

    const processedLines = lines.map((line, index) => {
      if (line.trim().startsWith('```')) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          return `${listContent}`;
        }
        inCodeBlock = !inCodeBlock;
        return line;
      }

      if (inCodeBlock) {
        return `<div class="${styles.previewCodeLine}">${escapeHtml(
          line
        )}</div>`;
      }

      const numberedMatch = line.match(
        /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/
      );
      const bulletMatch = line.match(/^[-*+]\s/);
      const isListItem = numberedMatch || bulletMatch;
      const isHeading = line.match(/^#{1,6}\s/);
      const isQuote = line.match(/^>\s/);
      const isEmpty = line.trim() === '';

      if (isHeading) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          const level = line.match(/^(#{1,6})\s/)?.[1].length || 1;
          const content = line.replace(/^#{1,6}\s/, '');
          return `${listContent}<h${level} class="${
            styles[`previewH${level}`]
          }">${content}</h${level}>`;
        }
        const level = line.match(/^(#{1,6})\s/)?.[1].length || 1;
        const content = line.replace(/^#{1,6}\s/, '');
        return `<h${level} class="${
          styles[`previewH${level}`]
        }">${content}</h${level}>`;
      }

      if (isQuote) {
        if (inList) {
          inList = false;
          const listContent = listBuffer.join('');
          listBuffer = [];
          const content = line.replace(/^>\s/, '');
          return `${listContent}<blockquote class="${styles.previewBlockquote}">${content}</blockquote>`;
        }
        const content = line.replace(/^>\s/, '');
        return `<blockquote class="${styles.previewBlockquote}">${content}</blockquote>`;
      }

      if (isListItem) {
        let content = line;

        const isNumbered = !!numberedMatch;
        const tag = isNumbered ? 'ol' : 'ul';

        let level = 0;
        let displayNumber = '';

        let nomerVstavit = '';

        if (isNumbered && numberedMatch) {
          const numberStr = numberedMatch[1];
          const levels = numberStr.split('.');
          for (let i = 0; i < levels.length; i += 1) {
            nomerVstavit = `${nomerVstavit}${levels[i]}.`;
          }
          level = levels.length - 1;
          displayNumber = levels[levels.length - 1];
          listCounter = parseInt(displayNumber, 10);

          content = content.replace(
            /^\s*(?:\*\*)?(\d+(?:\.\d+)*)\.(?:\*\*)?\s/,
            ''
          );
        } else if (bulletMatch) {
          level = 3;
          content = content.replace(/^[-*+]\s/, '');
        }

        content = processInlineMarkdown(content);

        const paddingLeft = 20 + level * 20;
        const showFullNumber = level > 0 && isNumbered ? nomerVstavit : '';
        const listStyle =
          level > 0 && isNumbered
            ? // eslint-disable-next-line prefer-template
              'list-style: none; padding-left: ' +
              paddingLeft +
              'px; margin-left: 0;'
            : 'padding-left: ' + paddingLeft + 'px; margin-left: 0;';

        if (!inList || listTag !== tag || currentListLevel !== level) {
          if (inList) {
            const prevListContent = listBuffer.join('') + `</${listTag}>`;
            listBuffer = [];
            listTag = tag;
            inList = true;
            currentListLevel = level;

            const startAttr = isNumbered ? ` start="${listCounter}"` : '';
            listBuffer.push(
              `<${tag}${startAttr} class="${styles.previewList}" style="${listStyle}"><li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
            );
            return prevListContent;
          }
          listTag = tag;
          inList = true;
          currentListLevel = level;

          const startAttr = isNumbered ? ` start="${listCounter}"` : '';
          listBuffer.push(
            `<${tag}${startAttr} class="${styles.previewList}" style="${listStyle}"><li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
          );
          return '';
        }

        listBuffer.push(
          `<li class="${styles.previewListItem}">${showFullNumber}${content}</li>`
        );
        return '';
      }

      if (inList) {
        inList = false;
        const listContent = listBuffer.join('') + `</${listTag}>`;
        listBuffer = [];
        currentListLevel = 0;
        listCounter = 1;

        if (isEmpty) {
          return `${listContent}<br>`;
        }

        return `${listContent}<p class="${
          styles.previewParagraph
        }">${processInlineMarkdown(line)}</p>`;
      }

      if (isEmpty) {
        return '<br>';
      }

      return `<p class="${styles.previewParagraph}">${processInlineMarkdown(
        line
      )}</p>`;
    });

    if (inList) {
      const listContent = listBuffer.join('') + `</${listTag}>`;
      processedLines.push(listContent);
    }

    return processedLines
      .join('\n')
      .replace(
        /\[(.*?)\]\(anatatlas:\/\/(.*?)\)/gim,
        `<a href="anatatlas://$2" class="${styles.anatomyLink}" title="Открыть в анатомическом атласе">$1</a>`
      );
  };

  // Функция рендеринга для gap_fill
  const renderGapFillOptions = () => {
    if (!dto || dto.type !== 'gap_fill') return null;

    const options = dto.options as OptionDto[];
    return (
      <Stack spacing={1} width="100%">
        <Typography fontWeight={600} fontSize="12px">
          Варианты для заполнения:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {options?.map((item, index) => (
            <Chip
              key={index}
              label={item.title}
              color={item.isDistractor ? 'error' : 'primary'}
              variant={item.isDistractor ? 'outlined' : 'filled'}
              size="small"
            />
          ))}
        </Box>
      </Stack>
    );
  };

  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const { section } = useParams();

  const [testDto, setTestDto] = useState(dto);

  const getAuthor = (authorId: number) => {
    if (authorId === 1) {
      return 'Привес';
    }
    if (authorId === 2) {
      return 'Сапин';
    }
    if (authorId === 3) {
      return 'Гайваронский';
    }
    return 'Общий';
  };

  const getTypeLabel = (type: string) => {
    switch (type) {
      case 'text':
        return 'Текстовый';
      case 'word_part_selection':
        return 'Выбор части слова';
      case 'latin_ending_picker':
        return 'Выбор латинского окончания';
      case 'ordering':
        return 'Упорядочивание';
      case 'categorization':
        return 'Категоризация';
      case 'gap_fill':
        return 'Заполнение пропусков';
      default:
        return type;
    }
  };

  const saveText = async (route: string, key: string, title: string) => {
    const apiResult: IApiResult = await apiSaveTest(route, key, title, testDto);
    if (apiResult.isSuccess) {
      setAlertProps({
        message: 'Данные записаны',
        severity: AlertSeverityEnum.info,
      });
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const setArrayOprions = (value: string, index: number) => {
    const array = testDto?.options;
    if (array !== undefined && testDto !== undefined) {
      array[index] = value;
      setTestDto({ ...testDto, options: array });
    }
  };

  const setArrayCorrectOprions = (value: string, index: number) => {
    const array = testDto?.correctOptions;
    if (array !== undefined && testDto !== undefined) {
      array[index] = value;
      setTestDto({ ...testDto, correctOptions: array });
    }
  };

  // Рендер для текстового теста
  const renderTextTest = () => (
    <Stack alignItems="center" justifyContent="center" spacing={1}>
      <Stack spacing={1} width="100%">
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '13px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Вопрос {num}.</span>
          {` ${testDto?.question}`}
        </Typography>
        {testDto?.stem !== '' && (
          <Card sx={{ background: '#46dd6c', width: '90%', padding: '5px' }}>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                width: '100%',
                fontSize: '11px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              Окончание для слова: {testDto?.stem}
            </Typography>
          </Card>
        )}
        {testDto?.subtitle && testDto.subtitle !== '' && (
          <Typography
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 500,
              width: '100%',
              fontSize: '12px',
              color: '#666666',
              letterSpacing: 1,
            }}
            component="text"
          >
            {` ${testDto?.subtitle}`}
          </Typography>
        )}
        {testDto?.hint && (
          <Card sx={{ background: '#e1bee7', width: '90%', padding: '5px' }}>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                width: '100%',
                fontSize: '11px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              💡 {testDto?.hint}
            </Typography>
          </Card>
        )}
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '11px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Тип теста:</span>
          {` ${getTypeLabel(testDto?.type ?? 'text')}.`}
          <span style={{ fontWeight: 700 }}> Автор:</span>
          {` ${getAuthor(testDto?.authorId ?? 0)}`}
        </Typography>
      </Stack>

      {/* Варианты ответов */}
      {(testDto?.type === 'text' ||
        testDto?.type === 'word_part_selection' ||
        testDto?.type === 'latin_ending_picker' ||
        testDto?.type === 'ordering') &&
        renderTextOptions()}

      {/* Подсказки к ответам - НОВАЯ ВЕРСИЯ */}
      {testDto?.answerHints && Object.keys(testDto.answerHints).length > 0 && (
        <Stack spacing={1} width="100%" sx={{ mt: 1 }}>
          <Typography
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '12px',
              color: '#000000',
            }}
          >
            Пояснения к ответам:
          </Typography>
          {Object.entries(testDto.answerHints).map(([option, hint], index) => (
            <Stack key={index} spacing={1} width="100%">
              <Card
                sx={{
                  background: '#b2dfdb',
                  width: '90%',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  borderLeft: '3px solid #00897b',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'sans-serif',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    width: '100%',
                    fontSize: '11px',
                    color: '#000000',
                    letterSpacing: 0.5,
                  }}
                  component="text"
                >
                  <span style={{ fontWeight: 600, color: '#00695c' }}>
                    {option}:
                  </span>
                  {` ${hint}`}
                </Typography>
              </Card>
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  );

  // Рендер для категоризации
  const renderCategorizationTest = () => (
    <Stack alignItems="center" justifyContent="center" spacing={1}>
      <Stack spacing={1} width="100%">
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '13px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Вопрос {num}.</span>
          {` ${testDto?.question}`}
        </Typography>
        {testDto?.subtitle && testDto.subtitle !== '' && (
          <Typography
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 500,
              width: '100%',
              fontSize: '12px',
              color: '#666666',
              letterSpacing: 1,
            }}
            component="text"
          >
            {` ${testDto?.subtitle}`}
          </Typography>
        )}
        {testDto?.hint && (
          <Card sx={{ background: '#e1bee7', width: '90%', padding: '5px' }}>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                width: '100%',
                fontSize: '11px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              💡 {testDto?.hint}
            </Typography>
          </Card>
        )}
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '11px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Тип теста:</span>
          {` ${getTypeLabel(testDto?.type ?? 'text')}.`}
          <span style={{ fontWeight: 700 }}> Автор:</span>
          {` ${getAuthor(testDto?.authorId ?? 0)}`}
        </Typography>
      </Stack>

      {/* Категории */}
      {testDto?.categories && testDto.categories.length > 0 && (
        <Stack spacing={2} width="100%" sx={{ mt: 1 }}>
          <Typography
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '12px',
              color: '#000000',
            }}
          >
            Категории:
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {testDto?.categories?.map((category, index) => (
              <Chip
                key={index}
                label={`${category.title} ${
                  category.capacity ? `(макс: ${category.capacity})` : ''
                }`}
                color="primary"
                variant="outlined"
                size="small"
              />
            ))}
          </Box>
        </Stack>
      )}

      {/* Сущности */}
      {testDto?.entities && testDto.entities.length > 0 && (
        <Stack spacing={1} width="100%" sx={{ mt: 1 }}>
          <Stack spacing={0.5} sx={{ mt: 0.5 }}>
            {testDto?.entities?.map((entity, index) => (
              <Typography
                key={index}
                style={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '11px',
                  color: '#333333',
                  letterSpacing: 0.5,
                }}
                component="text"
              >
                • {entity.title}
                {entity.categoryID &&
                  ` → ${
                    testDto?.categories?.find((c) => c.id === entity.categoryID)
                      ?.title || entity.categoryID
                  }`}
                {entity.isDistractor && ' (нет категории)'}
                {entity.isLocked && ' 🔒'}
              </Typography>
            ))}
          </Stack>
        </Stack>
      )}
    </Stack>
  );

  // Рендер для gap_fill
  const renderGapFillTest = () => (
    <Stack alignItems="center" justifyContent="center" spacing={1}>
      <Stack spacing={1} width="100%">
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '13px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Вопрос {num}.</span>
          {` ${testDto?.question}`}
        </Typography>
        {testDto?.subtitle && testDto.subtitle !== '' && (
          <Typography
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 500,
              width: '100%',
              fontSize: '12px',
              color: '#666666',
              letterSpacing: 1,
            }}
            component="text"
          >
            {` ${testDto?.subtitle}`}
          </Typography>
        )}
        {testDto?.hint && (
          <Card sx={{ background: '#e1bee7', width: '90%', padding: '5px' }}>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                width: '100%',
                fontSize: '11px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              💡 {testDto?.hint}
            </Typography>
          </Card>
        )}
        <Typography
          style={{
            fontFamily: 'sans-serif',
            fontStyle: 'normal',
            fontWeight: 500,
            width: '100%',
            fontSize: '11px',
            color: '#000000',
            letterSpacing: 1,
          }}
          component="text"
        >
          <span style={{ fontWeight: 700 }}>Тип теста:</span>
          {` ${getTypeLabel(testDto?.type ?? 'text')}.`}
          <span style={{ fontWeight: 700 }}> Автор:</span>
          {` ${getAuthor(testDto?.authorId ?? 0)}`}
        </Typography>
      </Stack>

      {/* Текст со слотами */}
      {testDto?.text && (
        <Stack spacing={1} width="100%" sx={{ mt: 1 }}>
          <Card sx={{ background: '#f5f5f5', padding: '10px', width: '90%' }}>
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '13px',
                color: '#000000',
                lineHeight: 1.8,
                letterSpacing: 0.5,
              }}
              component="text"
            >
              {testDto?.text}
            </Typography>
          </Card>
        </Stack>
      )}

      {/* Варианты ответов */}
      {testDto?.type === 'gap_fill' && renderGapFillOptions()}
    </Stack>
  );

  return (
    <div>
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />

      {testDto?.type === 'text' && renderTextTest()}
      {testDto?.type === 'word_part_selection' && renderTextTest()}
      {testDto?.type === 'latin_ending_picker' && renderTextTest()}
      {testDto?.type === 'ordering' && renderTextTest()}
      {testDto?.type === 'categorization' && renderCategorizationTest()}
      {testDto?.type === 'gap_fill' && renderGapFillTest()}
      {testDto?.reommdd !== undefined && testDto?.reommdd !== '' && (
        <Card sx={{ width: '90%', padding: '5px' }}>
          <Stack>
            <div
              style={{ fontSize: '12px' }}
              dangerouslySetInnerHTML={{
                __html: renderMarkdown(testDto?.reommdd ?? ''),
              }}
            />
          </Stack>
        </Card>
      )}
    </div>
  );
};

DialogTestItem.defaultProps = {
  dto: undefined,
};
